import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../public/images/logo-bolagsverket.svg'


const _hoisted_1 = {
  key: 0,
  class: "environment"
}
const _hoisted_2 = { class: "page" }
const _hoisted_3 = { class: "rubrik" }

import { computed, ref, watch } from "vue";
import { RouteLocationNormalizedLoaded, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  props: {
    miljo: {}
  },
  setup(__props: any) {


const props = __props;

const router = useRouter();
const testMiljoer = ["dev", "proj9", "system", "accept"];
const currentRoute = ref<RouteLocationNormalizedLoaded>(router.currentRoute.value);
const valdMiljo = ref(props.miljo);
const skaVisaMiljo = computed(() => props.miljo !== null && props.miljo !== "" && props.miljo !== "prod");

const bytMiljo = () => {
if (valdMiljo.value === "dev") {
    window.location.href = "http://localhost:8080/";
  } else {
    window.location.href = 
      "https://sta-kvar-" + valdMiljo.value + ".bolagsverket.se";
  }
};

watch(
  () => props.miljo,
  (current) => {
    valdMiljo.value = current;
  }
);

watch(
  () => router.currentRoute.value,
  (to) => {
    currentRoute.value = to;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", null, [
    (skaVisaMiljo.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createTextVNode(" Miljö: ", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valdMiljo).value = $event)),
            onChange: bytMiljo
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(testMiljoer, (miljo, index) => {
              return _createElementVNode("option", { key: index }, _toDisplayString(miljo), 1)
            }), 64))
          ], 544), [
            [_vModelSelect, valdMiljo.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'headerclass-inner-wide': currentRoute.value.path === '/sok' || currentRoute.value.path.startsWith('/foretag') || currentRoute.value.path === 'storlekskategori', 'headerclass-inner': currentRoute.value.path === '/' })
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "rubriklogga" }, [
          _createElementVNode("a", {
            href: "https://www.bolagsverket.se/",
            target: "_blank",
            rel: "noopener",
            "aria-label": "Bolagsverket, öppnas i nytt fönster"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logotyp, Bolagsverket"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("main.title")), 1)
      ], 2)
    ])
  ]))
}
}

})